/* eslint-disable sort-keys */
import textStyles from "../constants/textStyles";

export default {
    Checkbox: {
        parts: [
            "control", "icon", "label", "container",
        ],
        baseStyle: {},
        sizes: {},
        variants: {
            default: ({ theme }) => ({
                control: {
                    h: "4",
                    w: "4",
                    borderRadius: "3",
                    border: "1px solid",
                    borderColor: "secondary.100",
                    fontSize: textStyles.p3.fontsize,
                    color: "secondary.400",
                    bgColor: "secondary.100",
                    _active: {
                        borderColor: "secondary.100",
                    },
                    _checked: {
                        borderColor: "primary.400",
                        bg: "primary.400",
                        _hover : {
                            borderColor: "primary.400",
                            bg: "primary.400"
                        },
                        _disabled: {
                            borderColor: "primary.400",
                            bgColor: "primary.400",
                            opacity: "0.5"
                        },
                    },
                    _disabled: {
                        borderColor: "secondary.100",
                        bgColor: "secondary.100"
                    },
                    _hover: {
                        borderColor: "secondary.200",
                        bgColor: "secondary.200"
                    },
                    _focus: { boxShadow: "none", borderColor: "secondary.100" }

                },
                icon: {
                    // Need to use important here as Chakra sets stroke="currentcolor" inline, which cascades from body color (black)
                    stroke: `${theme.colors.white}!important`,
                    h: "5",
                    w: "5"
                }
            })
        },
        defaultProps: {
            variant: "default",
        }
    }
};
